import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'https://api.tinubu-ambode.org';

console.log('🚀 API Base URL:', API_BASE_URL);

const api = axios.create({
  baseURL: `${API_BASE_URL}/api/v1`,
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
  }
});

// Add token to all requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('jwt_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  
  // Log API calls for debugging
  if (config.url?.includes('/chat/')) {
    console.log(`💬 CHAT API: ${config.method?.toUpperCase()} ${config.url}`, config.params || '');
  }
  
  return config;
}, (error) => {
  console.error('❌ Request error:', error);
  return Promise.reject(error);
});

// Response interceptor
api.interceptors.response.use(
  (response) => {
    if (response.config.url?.includes('/chat/')) {
      console.log(`💬 CHAT API SUCCESS: ${response.status} ${response.config.url}`);
    }
    return response;
  },
  (error) => {
    console.error(`❌ API Error:`, {
      url: error.config?.url,
      status: error.response?.status,
      message: error.response?.data?.message || error.message
    });
    
    if (error.response?.status === 401) {
      console.log('🔐 Authentication failed, redirecting to login...');
      localStorage.removeItem('jwt_token');
      localStorage.removeItem('current_user_id');
      window.location.href = '/login';
    }
    
    return Promise.reject(error);
  }
);

export default api;